import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { AuthContext } from '../App';

// ==================== COMPONENTE PROFESOR: OTORGAR DENARIOS ====================
const ProfesorOtorgarDenarios = ({ API }) => {
  const [clases, setClases] = useState([]);
  const [claseSeleccionada, setClaseSeleccionada] = useState('');
  const [estudiantes, setEstudiantes] = useState([]);
  const [balanceProfesor, setBalanceProfesor] = useState(0);
  const [historialProfesor, setHistorialProfesor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [otorgando, setOtorgando] = useState(false);
  
  const [formOtorgar, setFormOtorgar] = useState({
    estudiante_id: '',
    denarios: 0,
    razon: ''
  });

  useEffect(() => {
    cargarDatosProfesor();
  }, []);

  const cargarDatosProfesor = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      
      console.log('🔍 API URL:', API);
      console.log('🔍 Full URL:', `${API}/denarios/balance-profesor`);
      console.log('🔍 Token:', token ? 'exists' : 'null');
      
      const balanceRes = await axios.get(`${API}/denarios/balance-profesor`, config);
      setBalanceProfesor(balanceRes.data.balance);
      setHistorialProfesor(balanceRes.data.historial || []);
      
      const clasesRes = await axios.get(`${API}/clases`, config);
      // Filtrar solo las clases donde el profesor es dueño (profesor_id)
      const profesorId = balanceRes.data.profesor_id;
      const clasesProfesor = (clasesRes.data || []).filter(clase => clase.profesor_id === profesorId);
      setClases(clasesProfesor);
      console.log('✅ Clases del profesor:', clasesProfesor.length);
    } catch (error) {
      console.error('Error cargando datos:', error);
      alert('Error al cargar datos: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  const cargarEstudiantes = async (claseId) => {
    if (!claseId) {
      setEstudiantes([]);
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get(`${API}/profesores/denarios/estudiantes-clase/${claseId}`, config);
      setEstudiantes(res.data.estudiantes || []);
    } catch (error) {
      console.error('Error cargando estudiantes:', error);
      alert('Error al cargar estudiantes: ' + (error.response?.data?.detail || error.message));
    }
  };

  const handleClaseChange = (claseId) => {
    setClaseSeleccionada(claseId);
    setFormOtorgar({ estudiante_id: '', denarios: 0, razon: '' });
    cargarEstudiantes(claseId);
  };

  const handleOtorgar = async (e) => {
    e.preventDefault();
    
    if (formOtorgar.denarios <= 0) {
      alert('La cantidad debe ser mayor a 0');
      return;
    }
    
    if (formOtorgar.denarios > balanceProfesor) {
      alert(`No tienes suficientes denarios. Tu balance es ${balanceProfesor}`);
      return;
    }
    
    if (!formOtorgar.razon.trim()) {
      alert('Debes especificar una razón');
      return;
    }
    
    if (window.confirm(`¿Otorgar ${formOtorgar.denarios} denarios? Tu nuevo balance será ${balanceProfesor - formOtorgar.denarios}`)) {
      setOtorgando(true);
      try {
        const token = localStorage.getItem('token');
        await axios.post(`${API}/profesores/denarios/otorgar-estudiante`, {
          estudiante_id: formOtorgar.estudiante_id,
          clase_id: claseSeleccionada,
          denarios: formOtorgar.denarios,
          razon: formOtorgar.razon
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        alert('✅ Denarios otorgados exitosamente');
        setFormOtorgar({ estudiante_id: '', denarios: 0, razon: '' });
        cargarDatosProfesor();
        cargarEstudiantes(claseSeleccionada);
      } catch (error) {
        console.error('Error:', error);
        alert('❌ Error: ' + (error.response?.data?.detail || error.message));
      } finally {
        setOtorgando(false);
      }
    }
  };

  const estudianteSeleccionado = estudiantes.find(e => e.id === formOtorgar.estudiante_id);

  if (loading) {
    return <div className="text-center py-8">Cargando...</div>;
  }

  return (
    <div className="space-y-6">
      <Card className="bg-gradient-to-r from-purple-50 to-indigo-50 border-2 border-purple-300">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-purple-900 mb-1">Tu Balance Actual</h3>
              <p className="text-sm text-purple-700">Denarios disponibles para otorgar</p>
            </div>
            <div className="text-5xl font-bold text-purple-600">
              {balanceProfesor} <span className="text-2xl">💰</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Otorgar Denarios a Estudiantes</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleOtorgar} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">1. Selecciona tu Clase</label>
              <select
                value={claseSeleccionada}
                onChange={(e) => handleClaseChange(e.target.value)}
                className="w-full p-3 border-2 border-purple-300 rounded-lg"
                required
              >
                <option value="">-- Selecciona una clase --</option>
                {clases.map(clase => (
                  <option key={clase.id} value={clase.id}>{clase.titulo}</option>
                ))}
              </select>
            </div>

            {claseSeleccionada && (
              <>
                <div>
                  <label className="block text-sm font-medium mb-2">2. Selecciona el Estudiante</label>
                  <select
                    value={formOtorgar.estudiante_id}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, estudiante_id: e.target.value }))}
                    className="w-full p-3 border-2 border-purple-300 rounded-lg"
                    required
                  >
                    <option value="">-- Selecciona un estudiante --</option>
                    {estudiantes.map(est => (
                      <option key={est.id} value={est.id} disabled={!est.puede_recibir_mas}>
                        {est.nombre} - Ya: {est.denarios_ya_otorgados}/20 {!est.puede_recibir_mas && '(Máx)'}
                      </option>
                    ))}
                  </select>
                  
                  {estudianteSeleccionado && (
                    <p className="mt-2 text-sm text-blue-600">
                      Ya le diste {estudianteSeleccionado.denarios_ya_otorgados}. Puedes dar {estudianteSeleccionado.denarios_restantes} más.
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">3. Cantidad</label>
                  <input
                    type="number"
                    value={formOtorgar.denarios}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, denarios: parseInt(e.target.value) || 0 }))}
                    min="1"
                    max={estudianteSeleccionado ? estudianteSeleccionado.denarios_restantes : 20}
                    className="w-full p-3 border-2 border-purple-300 rounded-lg"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">4. Razón</label>
                  <textarea
                    value={formOtorgar.razon}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, razon: e.target.value }))}
                    placeholder="Ej: Excelente participación"
                    className="w-full p-3 border-2 border-purple-300 rounded-lg h-24"
                    required
                  />
                </div>

                <Button 
                  type="submit" 
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white py-4"
                  disabled={otorgando || formOtorgar.denarios > balanceProfesor}
                >
                  {otorgando ? 'Otorgando...' : `Otorgar ${formOtorgar.denarios} Denarios`}
                </Button>
              </>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

// ==================== COMPONENTE ADMIN: GESTIÓN PROFESORES ====================
const AdminGestionProfesores = ({ API }) => {
  const [profesores, setProfesores] = useState([]);
  const [semestres, setSemestres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ejecutandoJob, setEjecutandoJob] = useState(false);
  const [resultadoJob, setResultadoJob] = useState(null);
  
  const [formOtorgar, setFormOtorgar] = useState({
    profesor_id: '',
    denarios: 0,
    razon: ''
  });
  const [otorgando, setOtorgando] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      
      const [profRes, semRes] = await Promise.all([
        axios.get(`${API}/users?rol=profesor`, config),
        axios.get(`${API}/semestres`, config)
      ]);
      
      setProfesores(profRes.data || []);
      setSemestres(semRes.data || []);
    } catch (error) {
      console.error('Error cargando datos:', error);
      alert('Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleOtorgarAProfesor = async (e) => {
    e.preventDefault();
    
    if (formOtorgar.denarios <= 0 || !formOtorgar.razon.trim()) {
      alert('Completa todos los campos');
      return;
    }
    
    const profesor = profesores.find(p => p.id === formOtorgar.profesor_id);
    if (!profesor || !window.confirm(`¿Otorgar ${formOtorgar.denarios} denarios a ${profesor.nombre}?`)) return;
    
    setOtorgando(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/admin/denarios/otorgar-profesor`, {
        profesor_id: formOtorgar.profesor_id,
        denarios: formOtorgar.denarios,
        razon: formOtorgar.razon
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      alert('✅ Denarios otorgados al profesor');
      setFormOtorgar({ profesor_id: '', denarios: 0, razon: '' });
    } catch (error) {
      alert('❌ Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setOtorgando(false);
    }
  };

  const ejecutarJobEstudiantes = async (semestreId) => {
    if (!semestreId || !window.confirm('¿Ejecutar cálculo de 20 denarios × estudiante?')) return;
    
    setEjecutandoJob(true);
    setResultadoJob(null);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/admin/denarios/calcular-estudiantes-registrados`, 
        { semestre_id: semestreId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setResultadoJob(res.data);
      alert('✅ Cálculo completado');
    } catch (error) {
      alert('❌ Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setEjecutandoJob(false);
    }
  };

  if (loading) return <div className="text-center py-8">Cargando...</div>;

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader><CardTitle>Otorgar Denarios a Profesor</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={handleOtorgarAProfesor} className="space-y-4">
            <select
              value={formOtorgar.profesor_id}
              onChange={(e) => setFormOtorgar(prev => ({ ...prev, profesor_id: e.target.value }))}
              className="w-full p-3 border rounded-lg"
              required
            >
              <option value="">-- Selecciona profesor --</option>
              {profesores.map(p => (
                <option key={p.id} value={p.id}>{p.nombre} {p.apellido}</option>
              ))}
            </select>
            
            <input
              type="number"
              value={formOtorgar.denarios}
              onChange={(e) => setFormOtorgar(prev => ({ ...prev, denarios: parseInt(e.target.value) || 0 }))}
              min="1"
              className="w-full p-3 border rounded-lg"
              placeholder="Cantidad"
              required
            />
            
            <textarea
              value={formOtorgar.razon}
              onChange={(e) => setFormOtorgar(prev => ({ ...prev, razon: e.target.value }))}
              className="w-full p-3 border rounded-lg h-24"
              placeholder="Razón..."
              required
            />
            
            <Button type="submit" className="w-full" disabled={otorgando}>
              {otorgando ? 'Otorgando...' : 'Otorgar'}
            </Button>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Job Día 14 - 20 Denarios × Estudiante</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-2">
            <select id="semestre-select" className="flex-1 p-3 border rounded-lg">
              <option value="">-- Semestre --</option>
              {semestres.map(s => (
                <option key={s.id} value={s.id}>{s.titulo}</option>
              ))}
            </select>
            <Button
              onClick={() => ejecutarJobEstudiantes(document.getElementById('semestre-select').value)}
              disabled={ejecutandoJob}
            >
              {ejecutandoJob ? 'Ejecutando...' : 'Ejecutar'}
            </Button>
          </div>

          {resultadoJob && (
            <div className="p-4 bg-green-50 border border-green-300 rounded-lg">
              <p><strong>Total otorgado:</strong> {resultadoJob.total_denarios_otorgados}</p>
              <p><strong>Clases:</strong> {resultadoJob.resultados?.length || 0}</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

// ==================== COMPONENTE PRINCIPAL ====================
const MisDenarios = () => {
  const { API, user: contextUser } = useContext(AuthContext);
  const [balance, setBalance] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [clasificacion, setClasificacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vistaActual, setVistaActual] = useState('balance'); // 'balance', 'historial', 'clasificacion', 'canjes', 'gestionar'
  const [user, setUser] = useState(null);
  
  // Estados para gestión de denarios (admin)
  const [usuarios, setUsuarios] = useState([]);
  const [formOtorgar, setFormOtorgar] = useState({
    estudiante_id: '',
    denarios: 0,
    accion: 'otorgamiento_manual',
    descripcion: ''
  });
  const [otorgando, setOtorgando] = useState(false);

  useEffect(() => {
    // Get user info from AuthContext (mejor que localStorage)
    if (contextUser) {
      console.log('User from AuthContext:', contextUser);
      setUser(contextUser);
      cargarDatos();
      
      // Cargar usuarios si es admin
      if (contextUser.rol === 'admin') {
        console.log('Loading users for admin...');
        cargarUsuarios();
      }
    } else {
      // Fallback a localStorage si no hay contexto
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      console.log('User from localStorage:', userData);
      setUser(userData);
      cargarDatos();
      
      if (userData && userData.rol === 'admin') {
        cargarUsuarios();
      }
    }
  }, [contextUser]);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      console.log('Cargando denarios...');
      
      // Usar Promise.allSettled para manejar errores individuales sin fallar todo
      const results = await Promise.allSettled([
        axios.get(`${API}/denarios/mi-balance`),
        axios.get(`${API}/denarios/historial?limit=20`),
        axios.get(`${API}/denarios/tabla-clasificacion?limit=10`)
      ]);
      
      // Balance (CRÍTICO - siempre debe cargarse)
      if (results[0].status === 'fulfilled') {
        console.log('Balance cargado:', results[0].value.data);
        setBalance(results[0].value.data);
      } else {
        console.error('Error loading balance:', results[0].reason);
        setBalance({
          denarios_totales: 0,
          nivel_actual: 'Sembrador',
          nivel_icono: '🌱',
          nivel_min: 0,
          nivel_max: 100,
          nivel_siguiente: 'Obrero',
          progreso_nivel: 0,
          denarios_para_siguiente: 100,
          racha_actual: 0,
          racha_maxima: 0
        });
      }
      
      // Historial (opcional)
      if (results[1].status === 'fulfilled') {
        console.log('Historial cargado:', results[1].value.data);
        setHistorial(results[1].value.data);
      } else {
        console.error('Error loading historial:', results[1].reason);
        setHistorial([]);
      }
      
      // Clasificación (opcional)
      if (results[2].status === 'fulfilled') {
        console.log('Clasificación cargada:', results[2].value.data);
        setClasificacion(results[2].value.data);
      } else {
        console.error('Error loading clasificación:', results[2].reason);
        setClasificacion({ top_estudiantes: [], mi_posicion: null });
      }
      
    } catch (error) {
      console.error('Error crítico loading denarios data:', error);
      console.error('Error details:', error.response?.data);
      // Set defaults in case of critical error
      setBalance({
        denarios_totales: 0,
        nivel_actual: 'Sembrador',
        nivel_icono: '🌱',
        nivel_min: 0,
        nivel_max: 100,
        nivel_siguiente: 'Obrero',
        progreso_nivel: 0,
        denarios_para_siguiente: 100,
        racha_actual: 0,
        racha_maxima: 0
      });
      setHistorial([]);
      setClasificacion({ top_estudiantes: [], mi_posicion: null });
    } finally {
      setLoading(false);
    }
  };

  const cargarUsuarios = async () => {
    try {
      const response = await axios.get(`${API}/api/users`);
      setUsuarios(response.data);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
    }
  };

  const otorgarDenarios = async (e) => {
    e.preventDefault();
    
    if (!formOtorgar.estudiante_id || formOtorgar.denarios <= 0 || !formOtorgar.descripcion) {
      alert('Por favor completa todos los campos correctamente');
      return;
    }

    setOtorgando(true);
    try {
      const response = await axios.post(`${API}/api/denarios/otorgar`, formOtorgar);
      
      alert(`✅ ${response.data.message}\n\nDenarios otorgados: ${response.data.denarios_otorgados}\nNuevo total: ${response.data.nuevo_total}\nNivel: ${response.data.nuevo_nivel}`);
      
      // Reset form
      setFormOtorgar({
        estudiante_id: '',
        denarios: 0,
        accion: 'otorgamiento_manual',
        descripcion: ''
      });
      
      // Reload data
      cargarDatos();
      
    } catch (error) {
      console.error('Error otorgando denarios:', error);
      alert('❌ Error al otorgar denarios: ' + (error.response?.data?.detail || error.message));
    } finally {
      setOtorgando(false);
    }
  };

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString('es-UY', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="container mx-auto p-4 sm:p-6">
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <i className="fas fa-spinner fa-spin text-4xl text-purple-600 mb-4"></i>
            <p className="text-gray-600">Cargando tus denarios...</p>
          </div>
        </div>
      </div>
    );
  }

  // Si no hay balance después de cargar, mostrar mensaje
  if (!balance) {
    return (
      <div className="container mx-auto p-4 sm:p-6">
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <i className="fas fa-exclamation-circle text-4xl text-gray-400 mb-4"></i>
            <p className="text-gray-600 mb-4">No se pudieron cargar los denarios</p>
            <Button onClick={() => window.location.reload()} className="bg-purple-600 hover:bg-purple-700 text-white">
              <i className="fas fa-redo mr-2"></i>
              Reintentar
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 sm:p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 flex items-center gap-2 mb-2">
          <span className="text-3xl">💰</span>
          Mis Denarios
        </h1>
        <p className="text-gray-600">
          Sistema de recompensas por participación y uso de la plataforma
        </p>
      </div>

      {/* Navigation Tabs */}
      <div className="flex gap-2 mb-6 border-b overflow-x-auto">
        <Button
          variant={vistaActual === 'balance' ? 'default' : 'ghost'}
          onClick={() => setVistaActual('balance')}
          className="whitespace-nowrap"
        >
          <i className="fas fa-coins mr-2"></i>
          Mi Balance
        </Button>
        <Button
          variant={vistaActual === 'historial' ? 'default' : 'ghost'}
          onClick={() => setVistaActual('historial')}
          className="whitespace-nowrap"
        >
          <i className="fas fa-history mr-2"></i>
          Historial
        </Button>
        <Button
          variant={vistaActual === 'clasificacion' ? 'default' : 'ghost'}
          onClick={() => setVistaActual('clasificacion')}
          className="whitespace-nowrap"
        >
          <i className="fas fa-trophy mr-2"></i>
          Clasificación
        </Button>
        
        <Button
          variant={vistaActual === 'niveles' ? 'default' : 'ghost'}
          onClick={() => setVistaActual('niveles')}
          className="whitespace-nowrap"
        >
          <i className="fas fa-layer-group mr-2"></i>
          Niveles
        </Button>
        
        <Button
          variant={vistaActual === 'canjes' ? 'default' : 'ghost'}
          onClick={() => setVistaActual('canjes')}
          className="whitespace-nowrap"
        >
          <i className="fas fa-gift mr-2"></i>
          Canjes
        </Button>
        
        {/* Profesor-only tab */}
        {user?.rol === 'profesor' && (
          <Button
            variant={vistaActual === 'otorgar' ? 'default' : 'ghost'}
            onClick={() => setVistaActual('otorgar')}
            className="whitespace-nowrap bg-gradient-to-r from-purple-500 to-indigo-500 text-white hover:from-purple-600 hover:to-indigo-600"
          >
            <i className="fas fa-hand-holding-heart mr-2"></i>
            Otorgar a Estudiantes
          </Button>
        )}
        
        {/* Admin-only tabs */}
        {user?.rol === 'admin' && (
          <>
            <Button
              variant={vistaActual === 'profesores' ? 'default' : 'ghost'}
              onClick={() => setVistaActual('profesores')}
              className="whitespace-nowrap bg-gradient-to-r from-green-500 to-teal-500 text-white hover:from-green-600 hover:to-teal-600"
            >
              <i className="fas fa-chalkboard-teacher mr-2"></i>
              Profesores
            </Button>
            <Button
              variant={vistaActual === 'gestionar' ? 'default' : 'ghost'}
              onClick={() => setVistaActual('gestionar')}
              className="whitespace-nowrap"
            >
              <i className="fas fa-user-shield mr-2"></i>
              Gestionar
            </Button>
          </>
        )}
      </div>

      {/* Balance View */}
      {vistaActual === 'balance' && balance && (
        <div className="space-y-6">
          {/* Main Balance Card */}
          <Card className="bg-gradient-to-br from-purple-600 to-pink-600 text-white border-0">
            <CardContent className="p-6">
              <div className="text-center">
                <p className="text-purple-100 mb-2">Balance Total</p>
                <div className="text-5xl sm:text-6xl font-bold mb-4">
                  {balance.denarios_totales} ₯
                </div>
                <div className="flex items-center justify-center gap-2 text-lg">
                  <span className="text-3xl">{balance.nivel_icono}</span>
                  <span className="font-semibold">{balance.nivel_actual}</span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Level Progress */}
          {balance.nivel_siguiente && (
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <i className="fas fa-chart-line text-blue-600"></i>
                  Progreso al Siguiente Nivel
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between text-sm mb-2">
                      <span className="text-gray-600">
                        {balance.nivel_actual} {balance.nivel_icono}
                      </span>
                      <span className="text-gray-600">
                        {balance.nivel_siguiente} {obtener_info_nivel(balance.nivel_siguiente)?.icono}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-4">
                      <div
                        className="bg-gradient-to-r from-purple-600 to-pink-600 h-4 rounded-full transition-all duration-500"
                        style={{
                          width: `${(balance.progreso_nivel / (balance.nivel_max - balance.nivel_min)) * 100}%`
                        }}
                      ></div>
                    </div>
                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                      <span>{balance.nivel_min} ₯</span>
                      <span>{balance.denarios_totales} ₯</span>
                      <span>{balance.nivel_max} ₯</span>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-sm text-blue-800">
                      <i className="fas fa-info-circle mr-2"></i>
                      Necesitas <strong>{balance.denarios_para_siguiente} ₯</strong> más para alcanzar el nivel <strong>{balance.nivel_siguiente}</strong>
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}

          {/* Streaks */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Card>
              <CardContent className="p-6">
                <div className="text-center">
                  <div className="text-4xl mb-2">🔥</div>
                  <p className="text-gray-600 text-sm mb-1">Racha Actual</p>
                  <p className="text-3xl font-bold text-orange-600">{balance.racha_actual}</p>
                  <p className="text-xs text-gray-500">días consecutivos</p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="text-center">
                  <div className="text-4xl mb-2">⭐</div>
                  <p className="text-gray-600 text-sm mb-1">Racha Máxima</p>
                  <p className="text-3xl font-bold text-purple-600">{balance.racha_maxima}</p>
                  <p className="text-xs text-gray-500">días consecutivos</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* How to Earn */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <i className="fas fa-lightbulb text-yellow-600"></i>
                ¿Cómo Ganar Denarios?
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {user?.rol === 'estudiante' ? (
                  <>
                    <div className="flex items-start gap-3">
                      <div className="bg-green-100 p-2 rounded">
                        <i className="fas fa-check text-green-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Asistir a Clases</p>
                        <p className="text-sm text-gray-600">10 ₯ por clase</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-orange-100 p-2 rounded">
                        <i className="fas fa-calendar text-orange-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Asistir a Eventos</p>
                        <p className="text-sm text-gray-600">15 ₯ por evento</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-pink-100 p-2 rounded">
                        <i className="fas fa-users text-pink-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Uso Diario</p>
                        <p className="text-sm text-gray-600">5 ₯ por día activo</p>
                      </div>
                    </div>
                  </>
                ) : (user?.rol === 'profesor' || user?.rol === 'pastor') ? (
                  <>
                    <div className="flex items-start gap-3">
                      <div className="bg-green-100 p-2 rounded">
                        <i className="fas fa-chalkboard-teacher text-green-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Impartir Clases</p>
                        <p className="text-sm text-gray-600">10 ₯ cuando primer estudiante asiste</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-blue-100 p-2 rounded">
                        <i className="fas fa-check text-blue-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Asistir a Eventos</p>
                        <p className="text-sm text-gray-600">15 ₯ por evento</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-pink-100 p-2 rounded">
                        <i className="fas fa-users text-pink-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Uso Diario</p>
                        <p className="text-sm text-gray-600">5 ₯ por día activo</p>
                      </div>
                    </div>
                  </>
                ) : (
                  // Admin role
                  <>
                    <div className="flex items-start gap-3">
                      <div className="bg-blue-100 p-2 rounded">
                        <i className="fas fa-user-shield text-blue-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Gestión del Sistema</p>
                        <p className="text-sm text-gray-600">Supervisar y gestionar denarios</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-purple-100 p-2 rounded">
                        <i className="fas fa-gift text-purple-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Otorgar Denarios</p>
                        <p className="text-sm text-gray-600">Recompensar usuarios manualmente</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="bg-pink-100 p-2 rounded">
                        <i className="fas fa-users text-pink-600"></i>
                      </div>
                      <div>
                        <p className="font-semibold">Uso Diario</p>
                        <p className="text-sm text-gray-600">5 ₯ por día activo</p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* History View */}
      {vistaActual === 'historial' && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <i className="fas fa-history text-gray-600"></i>
              Historial de Transacciones
            </CardTitle>
          </CardHeader>
          <CardContent>
            {historial.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <i className="fas fa-inbox text-4xl mb-3"></i>
                <p>Aún no tienes transacciones</p>
                <p className="text-sm">
                  ¡Comienza a ganar denarios usando la plataforma!
                </p>
              </div>
            ) : (
              <div className="space-y-3">
                {historial.map((trans) => (
                  <div
                    key={trans.id}
                    className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition"
                  >
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">{trans.descripcion}</p>
                      <p className="text-sm text-gray-500">{trans.accion}</p>
                      <p className="text-xs text-gray-400">{formatearFecha(trans.fecha)}</p>
                    </div>
                    <div className={`text-xl font-bold ${trans.denarios > 0 ? 'text-green-600' : 'text-red-600'}`}>
                      {trans.denarios > 0 ? '+' : ''}{trans.denarios} ₯
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Leaderboard View */}
      {vistaActual === 'clasificacion' && clasificacion && (
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <i className="fas fa-trophy text-yellow-600"></i>
                Tabla de Clasificación
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {clasificacion.top_estudiantes.map((est) => (
                  <div
                    key={est.estudiante_id}
                    className={`flex items-center gap-4 p-4 rounded-lg transition ${
                      est.es_usuario_actual
                        ? 'bg-gradient-to-r from-purple-100 to-pink-100 border-2 border-purple-600'
                        : 'bg-gray-50 hover:bg-gray-100'
                    }`}
                  >
                    <div className="text-2xl font-bold w-8 text-center">
                      {est.posicion === 1 && '🥇'}
                      {est.posicion === 2 && '🥈'}
                      {est.posicion === 3 && '🥉'}
                      {est.posicion > 3 && <span className="text-gray-500">#{est.posicion}</span>}
                    </div>
                    
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">
                        {est.estudiante_nombre}
                        {est.es_usuario_actual && (
                          <span className="ml-2 text-xs bg-purple-600 text-white px-2 py-1 rounded">Tú</span>
                        )}
                      </p>
                      <p className="text-sm text-gray-600">
                        {est.nivel_icono} {est.nivel_actual}
                      </p>
                    </div>
                    
                    <div className="text-right">
                      <p className="text-xl font-bold text-purple-600">{est.denarios_totales} ₯</p>
                    </div>
                  </div>
                ))}
              </div>
              
              {clasificacion.mi_posicion && clasificacion.mi_posicion > 10 && (
                <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <i className="fas fa-info-circle mr-2"></i>
                    Tu posición actual: <strong>#{clasificacion.mi_posicion}</strong>
                  </p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}

      {/* Niveles View */}
      {vistaActual === 'niveles' && (
        <div className="space-y-6">
          {/* Header Card */}
          <Card className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white border-0">
            <CardContent className="p-6">
              <div className="text-center">
                <h2 className="text-3xl font-bold mb-2">🏆 Sistema de Niveles</h2>
                <p className="text-purple-100">
                  Sube de nivel acumulando denarios y desbloquea nuevos logros
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Current Level Highlight */}
          <Card className="border-4 border-purple-500 shadow-lg">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className="text-6xl">{balance?.nivel_icono}</div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="text-2xl font-bold text-gray-900">{balance?.nivel_actual}</h3>
                    <span className="bg-purple-600 text-white text-xs px-3 py-1 rounded-full font-semibold">
                      TU NIVEL ACTUAL
                    </span>
                  </div>
                  <p className="text-gray-600 mb-3">
                    Tienes <strong className="text-purple-600">{balance?.denarios_totales} ₯p</strong>
                  </p>
                  {balance?.nivel_siguiente && (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                      <p className="text-sm text-blue-800">
                        <i className="fas fa-arrow-up mr-2"></i>
                        Necesitas <strong>{balance?.denarios_para_siguiente} ₯p</strong> más para alcanzar 
                        <strong> {balance?.nivel_siguiente}</strong>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* All Levels */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <i className="fas fa-layer-group text-indigo-600"></i>
                Todos los Niveles Disponibles
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {/* Sembrador */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Sembrador' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">🌱</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Sembrador</h4>
                        {balance?.nivel_actual === 'Sembrador' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">El comienzo de tu camino en IBA Connect</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-semibold">
                          0 - 99 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Obrero */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Obrero' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">🛠️</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Obrero</h4>
                        {balance?.nivel_actual === 'Obrero' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Trabajador constante y dedicado</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold">
                          100 - 299 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Siervo Fiel */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Siervo Fiel' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">🙏</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Siervo Fiel</h4>
                        {balance?.nivel_actual === 'Siervo Fiel' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Comprometido con el servicio y la fe</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full font-semibold">
                          300 - 599 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mayordomo */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Mayordomo' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">📋</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Mayordomo</h4>
                        {balance?.nivel_actual === 'Mayordomo' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Gestor responsable y confiable</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full font-semibold">
                          600 - 999 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Administrador */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Administrador' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">🏛️</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Administrador</h4>
                        {balance?.nivel_actual === 'Administrador' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Líder con gran autoridad y sabiduría</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-pink-100 text-pink-800 px-3 py-1 rounded-full font-semibold">
                          1,000 - 1,999 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Intendente */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Intendente' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">👑</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Intendente</h4>
                        {balance?.nivel_actual === 'Intendente' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Guardián de la excelencia y la tradición</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full font-semibold">
                          2,000 - 3,499 ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sabio */}
                <div className={`p-5 rounded-lg border-2 transition-all ${
                  balance?.nivel_actual === 'Sabio' 
                    ? 'bg-purple-50 border-purple-500' 
                    : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}>
                  <div className="flex items-center gap-4">
                    <div className="text-5xl">⭐</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-xl font-bold text-gray-900">Sabio</h4>
                        {balance?.nivel_actual === 'Sabio' && (
                          <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded">TÚ ESTÁS AQUÍ</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Maestro de conocimiento supremo</p>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full font-semibold">
                          3,500+ ₯p
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Info adicional */}
              <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="fas fa-info-circle text-blue-600"></i>
                  ¿Cómo ganar denarios?
                </h4>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• <strong>5 ₯p</strong> por día activo en la plataforma</li>
                  <li>• Completar tareas y actividades asignadas</li>
                  <li>• Participar en eventos especiales</li>
                  <li>• Contribuir al aprendizaje de la comunidad</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Canjes View - Categorías */}
      {vistaActual === 'canjes' && (
        <div className="space-y-6">
          {/* Banner Principal */}
          <Card className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 border-0 text-white overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
            <CardContent className="p-8 relative z-10">
              <div className="text-center">
                <div className="mb-4">
                  <span className="text-7xl animate-bounce inline-block">🎁</span>
                </div>
                <h2 className="text-4xl font-bold mb-3">Canje de Denarios</h2>
                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 mb-4 inline-block">
                  <p className="text-2xl font-bold mb-1">Tu Saldo Actual</p>
                  <p className="text-5xl font-extrabold">{balance?.denarios_totales || 0} ₯</p>
                </div>
                <p className="text-lg text-white/90">
                  Elige una categoría para canjear tus denarios por increíbles beneficios
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Categorías de Canje */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Beneficios Académicos */}
            <Link to="/app/canjes/academicos" className="block group" data-testid="categoria-academicos">
              <Card className="border-0 bg-gradient-to-br from-blue-500 to-indigo-600 text-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="relative z-10">
                    <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      📚
                    </div>
                    <h3 className="text-2xl font-bold mb-3">Beneficios Académicos</h3>
                    <p className="text-white/90 mb-4">
                      Extensiones de tiempo, puntos extras y más
                    </p>
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-semibold">Ver opciones</span>
                      <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            {/* Material Digital */}
            <Link to="/app/canjes/materiales" className="block group" data-testid="categoria-materiales">
              <Card className="border-0 bg-gradient-to-br from-green-500 to-emerald-600 text-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="relative z-10">
                    <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      📖
                    </div>
                    <h3 className="text-2xl font-bold mb-3">Material Digital</h3>
                    <p className="text-white/90 mb-4">
                      eBooks, PDFs y recursos descargables
                    </p>
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-semibold">Ver opciones</span>
                      <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            {/* Certificados */}
            <Link to="/app/canjes/certificados" className="block group" data-testid="categoria-certificados">
              <Card className="border-0 bg-gradient-to-br from-purple-500 to-pink-600 text-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="relative z-10">
                    <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      🎓
                    </div>
                    <h3 className="text-2xl font-bold mb-3">Certificados</h3>
                    <p className="text-white/90 mb-4">
                      Diplomas y reconocimientos especiales
                    </p>
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-semibold">Ver opciones</span>
                      <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            {/* Privilegios */}
            <Link to="/app/canjes/privilegios" className="block group" data-testid="categoria-privilegios">
              <Card className="border-0 bg-gradient-to-br from-yellow-500 to-orange-600 text-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="relative z-10">
                    <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      ⭐
                    </div>
                    <h3 className="text-2xl font-bold mb-3">Privilegios</h3>
                    <p className="text-white/90 mb-4">
                      Beneficios y ventajas exclusivas
                    </p>
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-semibold">Ver opciones</span>
                      <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            {/* Otros */}
            <Link to="/app/canjes/otros" className="block group" data-testid="categoria-otros">
              <Card className="border-0 bg-gradient-to-br from-gray-600 to-gray-800 text-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer h-full">
                <CardContent className="p-8 text-center relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="relative z-10">
                    <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      🎯
                    </div>
                    <h3 className="text-2xl font-bold mb-3">Otros</h3>
                    <p className="text-white/90 mb-4">
                      Más opciones y sorpresas especiales
                    </p>
                    <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-semibold">Ver opciones</span>
                      <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Card className="border-2 border-dashed border-gray-300 opacity-60">
              <CardContent className="p-6 text-center">
                <i className="fas fa-star text-4xl text-gray-400 mb-3"></i>
                <h3 className="font-bold text-gray-600 mb-2">Privilegios Especiales</h3>
                <p className="text-sm text-gray-500">Badges y reconocimientos</p>
                <div className="mt-3 px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs inline-block">
                  Próximamente
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-dashed border-gray-300 opacity-60">
              <CardContent className="p-6 text-center">
                <i className="fas fa-heart text-4xl text-gray-400 mb-3"></i>
                <h3 className="font-bold text-gray-600 mb-2">Donaciones</h3>
                <p className="text-sm text-gray-500">Proyectos y misiones</p>
                <div className="mt-3 px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs inline-block">
                  Próximamente
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-dashed border-gray-300 opacity-60">
              <CardContent className="p-6 text-center">
                <i className="fas fa-ticket-alt text-4xl text-gray-400 mb-3"></i>
                <h3 className="font-bold text-gray-600 mb-2">Eventos Especiales</h3>
                <p className="text-sm text-gray-500">Retiros y conferencias</p>
                <div className="mt-3 px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs inline-block">
                  Próximamente
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-dashed border-gray-300 opacity-60">
              <CardContent className="p-6 text-center">
                <i className="fas fa-gift text-4xl text-gray-400 mb-3"></i>
                <h3 className="font-bold text-gray-600 mb-2">Productos Físicos</h3>
                <p className="text-sm text-gray-500">Merchandising y más</p>
                <div className="mt-3 px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs inline-block">
                  Próximamente
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Información adicional */}
          <Card className="bg-blue-50 border-blue-200">
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <i className="fas fa-info-circle text-3xl text-blue-600 mt-1"></i>
                <div>
                  <h3 className="font-bold text-blue-900 mb-2">¿Cómo funcionará?</h3>
                  <p className="text-blue-800 mb-3">
                    Muy pronto podrás usar tus denarios para obtener beneficios exclusivos, 
                    material educativo, participar en eventos especiales y mucho más.
                  </p>
                  <p className="text-blue-700 font-semibold">
                    💡 Mientras tanto, sigue ganando denarios completando actividades, 
                    planes de lectura bíblica y asignaciones.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Gestionar View - Admin Only */}
      {vistaActual === 'gestionar' && user?.rol === 'admin' && (
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <i className="fas fa-gift text-purple-600"></i>
                Otorgar Denarios a Usuarios
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={otorgarDenarios} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Usuario</label>
                  <select
                    value={formOtorgar.estudiante_id}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, estudiante_id: e.target.value }))}
                    className="w-full p-2 border rounded-md"
                    required
                  >
                    <option value="">Seleccionar usuario...</option>
                    {usuarios.map(usuario => (
                      <option key={usuario.id} value={usuario.id}>
                        {usuario.nombre} {usuario.apellido} - {usuario.rol} ({usuario.email})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Cantidad de Denarios</label>
                  <input
                    type="number"
                    value={formOtorgar.denarios}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, denarios: parseInt(e.target.value) || 0 }))}
                    className="w-full p-2 border rounded-md"
                    min="1"
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">Ingresa un número positivo para otorgar denarios</p>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Descripción / Motivo</label>
                  <textarea
                    value={formOtorgar.descripcion}
                    onChange={(e) => setFormOtorgar(prev => ({ ...prev, descripcion: e.target.value }))}
                    className="w-full p-2 border rounded-md"
                    rows={3}
                    placeholder="Ej: Premio por excelencia académica, Participación destacada en evento, etc."
                    required
                  />
                </div>

                <Button 
                  type="submit" 
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white"
                  disabled={otorgando}
                >
                  {otorgando ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Otorgando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-gift mr-2"></i>
                      Otorgar Denarios
                    </>
                  )}
                </Button>
              </form>

              <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h4 className="font-semibold text-blue-900 mb-2">
                  <i className="fas fa-info-circle mr-2"></i>
                  Información
                </h4>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• Los denarios otorgados se registran en el historial del usuario</li>
                  <li>• El nivel del usuario se actualizará automáticamente según su nuevo total</li>
                  <li>• Esta acción queda registrada en el sistema como "otorgamiento_manual"</li>
                  <li>• Puedes otorgar denarios a cualquier usuario (estudiantes, profesores, pastores, admins)</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      )}


      {/* Vista Otorgar - Solo Profesores */}
      {vistaActual === 'otorgar' && user?.rol === 'profesor' && (
        <ProfesorOtorgarDenarios API={API} />
      )}

      {/* Vista Profesores - Solo Admin */}
      {vistaActual === 'profesores' && user?.rol === 'admin' && (
        <AdminGestionProfesores API={API} />
      )}
    </div>
  );
};

// Helper function for level icon
const obtener_info_nivel = (nivel) => {
  const niveles = {
    "Sembrador": { icono: "🌱" },
    "Obrero": { icono: "🛠️" },
    "Siervo Fiel": { icono: "🙏" },
    "Mayordomo": { icono: "📋" },
    "Administrador": { icono: "🏛️" },
    "Intendente": { icono: "👑" },
    "Sabio": { icono: "⭐" }
  };
  return niveles[nivel] || niveles["Sembrador"];
};

export default MisDenarios;
